import template from './uc-theme-picker.html.twig';
import './uc-theme-picker.scss';

Shopware.Component.register('uc-theme-picker', {
    template,

    props: {
        value: {
            type: String,
            default: 'classic',
        },
    },

    emits: ['update:value'],

    data() {
        return {
            // Bold and Soft pulled per merchant request — the multi-theme
            // idea needs more design work before shipping (their words: "the
            // idea of multiple designs is good, but the execution needs a
            // bit more thinking"). Left commented out rather than deleted so
            // they're a one-line uncomment away when that work happens,
            // instead of having to be rebuilt from scratch. The underlying
            // support (--uc-color-* per-theme presets in _themes.scss, the
            // trust-bar theme-preset fallback map, snippet copy) is all
            // still in place — only the admin picker's selectable list
            // changed, so re-adding them here is the only step needed later.
            themes: [
                {
                    key: 'classic',
                    icon: '✦',
                    preview: ['#f7f1e6', '#ffffff', '#2f4a3d'],
                },
                // {
                //     key: 'bold',
                //     icon: '◼',
                //     preview: ['#111827', '#374151', '#0f69c4'],
                // },
                // {
                //     key: 'soft',
                //     icon: '◉',
                //     preview: ['#fef9f4', '#f0e8df', '#c084fc'],
                // },
            ],
        };
    },

    methods: {
        select(key) {
            this.$emit('update:value', key);
        },

        label(key) {
            return this.$tc(`sellops-ultimate-cart.theme.${key}.label`);
        },

        desc(key) {
            return this.$tc(`sellops-ultimate-cart.theme.${key}.desc`);
        },
    },
});
